var _path;
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9999 0.000243004L23.1799 2.82024L32.3399 12.0002L-6.17345e-05 12.0002L-6.15597e-05 16.0002L32.3399 16.0002L23.1599 25.1802L25.9999 28.0002L39.9999 14.0002L25.9999 0.000243004Z"
  }));
};
export default SvgArrowRight;